import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  // A list of all locales that are supported.
  locales: ['en'],

  // Used when no locale matches, e.g. if user's operating system locale is not in the `locales` list.
  defaultLocale: 'en',

  // https://next-intl-docs.vercel.app/docs/routing#locale-prefix-never
  // Technically, we could avoid using i18n routing and eliminate the need for [locale] folder, because:
  // 1. We don't need domain-based routing.
  // 2. We don't have pages with static rendering.
  // TODO: Remove the [locale] folder: https://next-intl-docs.vercel.app/docs/getting-started/app-router/without-i18n-routing
  localePrefix: 'never',
  // We don't use domains or subdomains for localization.
  domains: undefined,

  // This is false by default when `localePrefix` is `never`. This means we never add locale prefixes to URL pathnames.
  alternateLinks: false,

  // True by default. The cookie and the `accept-language` header will be used for locale detection.
  localeDetection: true,
})
